const CheckInGradientCircle = ({ ...props }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        width="20"
        height="20"
        rx="10"
        fill="url(#paint0_linear_12475_41659)"
      />
      <path
        d="M8.90954 11.0908L13.1995 6.79079C13.3869 6.60454 13.6404 6.5 13.9045 6.5C14.1687 6.5 14.4222 6.60454 14.6095 6.79079C14.7033 6.88376 14.7777 6.99436 14.8284 7.11622C14.8792 7.23807 14.9053 7.36878 14.9053 7.50079C14.9053 7.6328 14.8792 7.76351 14.8284 7.88537C14.7777 8.00723 14.7033 8.11783 14.6095 8.21079L9.60954 13.2108C9.42328 13.3955 9.17188 13.4997 8.90954 13.5008C8.77794 13.5016 8.64747 13.4763 8.52564 13.4266C8.4038 13.3768 8.29298 13.3035 8.19954 13.2108L5.84954 10.8508C5.74486 10.7611 5.65984 10.6508 5.59982 10.5268C5.53979 10.4027 5.50606 10.2676 5.50075 10.1298C5.49543 9.99213 5.51863 9.85479 5.56891 9.72647C5.61918 9.59815 5.69544 9.4816 5.79289 9.38414C5.89035 9.28669 6.0069 9.21043 6.13522 9.16016C6.26355 9.10988 6.40088 9.08667 6.5386 9.09199C6.67632 9.09731 6.81145 9.13104 6.93551 9.19107C7.05958 9.25109 7.1699 9.33611 7.25954 9.44079L8.90954 11.0908Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_12475_41659"
          x1="1.49012e-07"
          y1="20"
          x2="20.2682"
          y2="19.7244"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F4318F" />
          <stop offset="1" stopColor="#FE3C5F" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default CheckInGradientCircle;
